import React from 'react';
import { StarIcon } from 'lucide-react';
import { Reveal } from './Reveal';
import { testimonials, stats } from '../data/content';
export function SocialProofSection() {
  return <section className="w-full bg-navy-900 py-20 lg:py-24" aria-labelledby="proof-heading" data-id="element-150" data-mp="35q71sja6j25n">
      <div className="mx-auto max-w-7xl px-6 lg:px-8" data-id="element-151" data-mp="30r3xj120wzyq">
        <Reveal className="max-w-3xl" data-id="element-152" data-mp="30sezqwftlznq">
          <h2 id="proof-heading" className="text-3xl font-black leading-tight tracking-tight text-white sm:text-4xl lg:text-5xl" data-id="element-153" data-mp="30tgfvfbp1ccb">
            Trusted by top-performing agents worldwide
          </h2>
        </Reveal>

        <div className="mt-14 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-4" data-id="element-154" data-mp="2mzfox7qzgtmi">
          {testimonials.map((t, i) => <Reveal key={t.name} delay={i * 0.05} className="h-full" data-id="element-155" data-mp="2i0cs2al5ptpm" data-mpi={i}>
              <figure className="flex h-full flex-col rounded-2xl border border-white/10 bg-navy-900 p-7" style={{
            paddingTop: "0px",
            paddingBottom: "0px"
          }} data-id="element-156" data-mp="29ghr0hrioky">
                <div className="flex gap-0.5" aria-label="Rated 5 out of 5" data-id="element-157" data-mp="3tf9hhll96kxi">
                  {Array.from({
                length: 5
              }).map((_, s) => <StarIcon key={s} aria-hidden="true" className="h-4 w-4 fill-brand-gold text-brand-gold" data-id="element-158" data-mp="yhmvp845xvs9" data-mpi={s} />)}
                </div>
                <blockquote className="mt-5 text-[15px] leading-relaxed text-slate-200" data-id="element-159" data-mp="18cx2e95iarcd">
                  &ldquo;{t.quote}&rdquo;
                </blockquote>
                <figcaption className="mt-auto flex items-center gap-3 pt-7" data-id="element-160" data-mp="1ccxma9bdjuqt">
                  <img src={t.avatar} alt="" className="h-11 w-11 shrink-0 rounded-full object-cover ring-1 ring-white/15" width={88} height={88} data-id="element-161" data-mp="fqc5yua6bp1y" />
                  <div className="min-w-0" data-id="element-162" data-mp="oppjby1f4xry">
                    <p className="truncate text-sm font-bold text-white" data-id="element-163" data-mp="onwd2jupwfkh">
                      {t.name} <span className="font-medium text-slate-400" data-id="element-164" data-mp="th7iqhnsmqat">· {t.location}</span>
                    </p>
                    <p className="truncate text-xs text-slate-400" data-id="element-165" data-mp="3t35wfv4h6nfe">{t.title}</p>
                  </div>
                </figcaption>
              </figure>
            </Reveal>)}
        </div>

        <Reveal delay={0.08} data-id="element-166" data-mp="149r02sbe5qcr">
          <dl className="mt-14 grid grid-cols-2 gap-px overflow-hidden rounded-2xl border border-white/10 bg-white/10 lg:grid-cols-4" data-id="element-167" data-mp="148pl4cr98jpr">
            {stats.map(stat => <div key={stat.label} className="bg-navy-900 px-6 py-8 text-center" data-id="element-168" data-mp="1e0vcbk9omx3w">
                <dt className="sr-only" data-id="element-169" data-mp="190z75hp90zmr">{stat.label}</dt>
                <dd data-id="element-170" data-mp="192aj44suldoy">
                  <span className="block text-3xl font-black tracking-tight text-brand-gold sm:text-4xl" data-id="element-171" data-mp="lbwsmipwvmwh">
                    {stat.value}
                  </span>
                  <span className="mt-2 block text-xs font-medium uppercase tracking-widest text-slate-400" data-id="element-172" data-mp="geehclof8vlb">
                    {stat.label}
                  </span>
                </dd>
              </div>)}
          </dl>
        </Reveal>
      </div>
    </section>;
}